import { infiniteQueryOptions, queryOptions } from '@tanstack/react-query'
import { queryKeys } from '../keys'
import type {
  InfiniteData,
  UnusedSkipTokenInfiniteOptions,
  UnusedSkipTokenOptions,
} from '@tanstack/react-query'
import type { HTTPError } from 'ky'
import type { HttpErrorResponse } from '@/types/error'
import type {
  FaqsListQueryParam,
  GetFaqsCategoriesResponse,
  GetFaqsResponse,
} from '@/types/faqs'
import { INITIAL_PER_PAGE } from '@/utils/constant'
import { faqsService } from '@/services/faqs'

export const getFaqsQueryOptions = (
  params?: Pick<FaqsListQueryParam, 'category_id' | 'search'>,
  options?: Omit<
    UnusedSkipTokenInfiniteOptions<
      GetFaqsResponse,
      HTTPError<HttpErrorResponse>,
      InfiniteData<GetFaqsResponse, unknown>,
      ReturnType<typeof queryKeys.faqs.list>,
      number
    >,
    'queryKey' | 'queryFn' | 'initialPageParam' | 'getNextPageParam' | 'select'
  >,
) =>
  infiniteQueryOptions({
    initialPageParam: 1,
    queryKey: queryKeys.faqs.list(params),
    queryFn: ({ pageParam }) =>
      faqsService.getList({
        searchParams: {
          ...params,
          page: pageParam,
          per_page: INITIAL_PER_PAGE,
        },
      }),
    getNextPageParam: (lastPage) => lastPage?.meta?.next_page,
    ...options,
  })

export const getFaqsCategoriesQueryOptions = (
  options?: Omit<
    UnusedSkipTokenOptions<
      GetFaqsCategoriesResponse,
      HTTPError<HttpErrorResponse>,
      GetFaqsCategoriesResponse,
      ReturnType<typeof queryKeys.faqs.categories>
    >,
    'queryKey' | 'queryFn'
  >,
) =>
  queryOptions({
    queryKey: queryKeys.faqs.categories(),
    queryFn: () => faqsService.getCategories(),
    ...options,
  })
